// extracted by mini-css-extract-plugin
module.exports = {"sezzleWidget":"styles_sezzleWidget__hJZB8"};